module.exports = __webpack_public_path__ + "img/SLNRC logo.5b21bdab.jpg";